// import brandlogo from "../../../assets/images/chi/brandlogo2.png";
import logo1 from "../../../assets/images/chi/original-220322-ELTAMD-LOGO-RGB-01_(002)-014534.webp";
import logo2 from "../../../assets/images/chi/original-Untitled_design_(12)-033839-022202.webp";
import logo3 from "../../../assets/images/chi/augustinusbader-124221.webp";
import logo4 from "../../../assets/images/chi/original-SkinMedica-014608.webp";
import logo5 from "../../../assets/images/chi/original-Skinc-014559.webp";
import logo6 from "../../../assets/images/chi/original-original-RevitaLash-063108-125844.webp";

const FeateureBrad = () => {
  return (
    <div className="mt-20">
      <h1 className="text-center text-2xl mb-8">Feature Brands</h1>
      <div className=" flex flex-wrap justify-center gap-10  md:gap-10">
        <img className="w-32 object-contain" src={logo1} alt="" />
        <img className="w-32 object-contain" src={logo2} alt="" />
        <img className="w-32 object-contain" src={logo3} alt="" />
        <img className="w-32 object-contain" src={logo4} alt="" />
        <img className="w-32 object-contain" src={logo5} alt="" />
        <img className="w-32 object-contain" src={logo6} alt="" />
      </div>
    </div>
  );
};

export default FeateureBrad;
